import { clientApi } from 'shared/api/clientApi'
import { Response } from 'shared/models/general'

import type { EditObjectActiveRequest, EditObjectDraftRevision } from './model'

type EditObjectActiveResponse = Response<null>

export const KyrgyzstanEditObjectApi = {
  createObjectDraftRevision(objectId: string, signal?: AbortSignal) {
    return clientApi.post<Response<EditObjectDraftRevision>>(
      `/kyrgyzstan/webview-owner/realty-objects/${objectId}/revisions`,
      undefined,
      { signal },
    )
  },

  createRejectedDraftRevision(draftId: string, signal?: AbortSignal) {
    return clientApi.post<Response<EditObjectDraftRevision>>(
      `/kyrgyzstan/webview-owner/realty-objects/draft/${draftId}/revisions`,
      undefined,
      { signal },
    )
  },

  getDraftRevision(draftId: string, signal?: AbortSignal) {
    return clientApi.get<Response<EditObjectDraftRevision>>(
      `/kyrgyzstan/webview-owner/realty-objects/draft/revisions/${draftId}`,
      { signal },
    )
  },

  submitDraftRevision(draftId: string) {
    return clientApi.post<Response<unknown>>(
      `/kyrgyzstan/webview-owner/realty-objects/draft/revisions/${draftId}/submit`,
    )
  },

  deleteDraft(draftId: string) {
    return clientApi.delete<Response<null>>(
      `/kyrgyzstan/webview-owner/realty-objects/draft/${draftId}`,
    )
  },

  updateObjectActive(objectId: string, payload: EditObjectActiveRequest) {
    return clientApi.patch<EditObjectActiveResponse>(
      `/kyrgyzstan/webview-owner/realty-objects/${objectId}/active`,
      payload,
    )
  },
}
